<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-12 col-md-6 mt-2 col-lg-4  d-inline-block">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2 col-lg-4">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                    </div>
                </div>
                <div class="col-12 col-md-12 mt-2 col-lg-4 text-center">
                    <button class="btn btn-primary" @click="onModalButtonClick">افزودن محصول</button>
                    <button class="btn btn-primary" @click="onModalShow" v-if="baseProductSelected">مشاهده محصولات
                        میانی
                    </button>
                </div>
            </div>
        </div>
        <div class="m-2 col-12 text-center">
            <h3 v-if="baseProductSelected">
                لطفا محصولاتی که در تولید
                {{baseproduct.productName}}
                بکار رفته اند را انتخاب کنید
            </h3>
            <h3 v-else>لطفا محصول تولید شده را انتخاب کنید</h3>

        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-4">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-3">
                            <span>دسته بندی: </span>
                            <span>{{item.categoryName}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>واحد: </span>
                            <span v-if="units[item.unitId-1] !== undefined">{{units[item.unitId-1].unitName}}</span>
                        </div>
                        <!--<div class="col-md-3">-->
                        <!--<span>قیمت: </span>-->
                        <!--<span v-if="item.price === null" class="text-warning">قیمت ثبت نشده است!</span>-->
                        <!--<span v-else class="text-success">{{item.price.toLocaleString()}}</span>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>

                            <!--<span>موجودی انبار:</span>
                            <span>{{item.stock}}</span>-->
                            <!--<span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>-->
                            <span>دسته بندی:</span>
                            <span> {{item.categoryName}}</span>
                            <br>
                            <span>واحد:</span>
                            <span v-if="units[item.unitId-1] !== undefined"> {{units[item.unitId-1].unitName}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span> {{item.barcode}}</span>
                            <!--<div class="text-warning text-center mt-3" v-if="item.price === null">-->
                            <!--<h5 class="d-inline">قیمت ثبت نشده است!</h5>-->
                            <!--</div>-->
                            <!--<div v-else class="text-success text-center mt-3">-->
                            <!--<h5 class="d-inline">قیمت:</h5>-->
                            <!--<h5 class="d-inline"> {{item.price.toLocaleString()}}</h5>-->
                            <!--</div>-->
                        </div>
                        <div class="col-4 d-flex align-items-center">
                            <img src="../assets/img/placeholder.png" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12"
                 :style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3 mt-1"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>

            <!--*****************************************************************************************************************-->
            <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">

                        <div class="modal-body mt-3">
                            <div class="row">

                                <div class="col-lg-12 mt-3 text-center">
                                    <h5>ثبت تعداد کالای تولید شده</h5>
                                </div>
                                <div class="col-lg-12 m-2 ">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="baseproduct.productName">
                                    </div>
                                </div>
                                <div class="col-lg-12 m-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">تعداد</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="baseproduct.unitVal">
                                    </div>
                                </div>
                                <div class="col-lg-12 m-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">قیمت</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="baseproduct.price">
                                    </div>
                                </div>


                            </div>

                        </div>
                        <div class="modal-footer  d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                            <button type="button" class="btn btn-primary" @click="onModalOk">مرحله بعدی</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--*****************************************************************************************************************-->
            <div class="modal fade" id="newproductModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">ایجاد
                                محصول</h5>

                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="row">
                                <div class="col-lg-9 col-md-12 col-sm-12 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">دسته بندی</span>
                                        </div>
                                        <vs-select :data="categories" :selected-val="preselectedCategory"
                                                   :mode="'create'"
                                                   :header="{multiple: false, label: 'name'}"
                                                   @onChange="onCategoryChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                    <button class="btn btn-primary bg-danger-grad border-0"
                                            @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                            title="افزودن دسته بندی">افزودن دسته بندی
                                    </button>
                                </div>
                                <div class="col-lg-12 mt-3 mt-lg-0">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.productName">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">واحد</span>
                                        </div>
                                        <vs-select :data="units" :selected-val="preselectedUnit"
                                                   :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                                   @onChange="onUnitChange"></vs-select>
                                    </div>
                                </div>
                                <!--<div class="col-lg-6 mt-3">-->
                                <!--<div class="input-group">-->
                                <!--<button type="button" class="d-inline-block btn btn-info mx-2 barcode"-->
                                <!--@click="openBarcode"><i-->
                                <!--class="fa fa-camera"></i></button>-->
                                <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">بارکد</span>-->
                                <!--</div>-->
                                <!--<input class="form-control" type="number" v-model="product.barcode"  placeholder="برای قرائت بارکد روی آیکون کلیک کنید">-->
                                <!--</div>-->
                                <!--</div>-->
                            </div>

                        </div>
                        <div class="modal-footer d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onProductModalOk">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--*****************************************************************************************************************-->
            <div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="barcodTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="barcodTitle">خواندن بارکد
                                محصول</h5>

                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="row">
                                <div class="col-12">

                                    <StreamBarcodeReader
                                            @decode="(a, b, c) => onDecode(a, b, c)"
                                            @loaded="() => onLoaded()"
                                    ></StreamBarcodeReader>
                                    <h5 class="col-12 text-center m-3">
                                        {{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                            <!--<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>-->
                        </div>
                    </div>
                </div>
            </div>
            <!--*****************************************************************************************************************-->
            <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger glow-warning">
                            <h5 class="modal-title text-white">افزودن دسته بندی</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row text-center">
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">عنوان دسته بندی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="categoryName">
                                    </div>
                                </div>
                                <!--<div class="col-lg-6 mb-2">-->
                                <!--<div class="input-group">-->
                                <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">دسته بندی مادر</span>-->
                                <!--</div>-->
                                <!--<vs-select-->
                                <!--:data="categories"-->

                                <!--:mode="'create'"-->
                                <!--:header="{multiple: false, label: 'name'}"-->
                                <!--@onChange="onCategoryChange"-->
                                <!--&gt;</vs-select>-->
                                <!--</div>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onCreateCategory">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--*****************************************************************************************************************-->
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-nowrap">نام محصول میانی</th>
                                        <!--<th class="text-center">قیمت خرید</th>-->
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <!--<th class="text-center text-nowrap">قیمت</th>-->
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in middleProducts">
                                        <td class="product-remove-button text-nowrap pb-0"><a class="text-danger"
                                                                                              @click="onRemoveProductClicked(index)"><i
                                                class="fa fa-close"></i></a></td>
                                        <td class="min-vw-100 text-nowrap pb-0">{{item.productName}}</td>
                                        <td class="text-center">
                                            <input class="form-control" type="number" v-model="item.price">
                                        </td>
                                        <td class="text-center  pb-0">
                                            <input class="form-control" style="min-width: 4rem;" type="number"
                                                   v-model="item.unitVal">
                                            <small class="text-nowrap mt-2">{{item.unitName}}</small>
                                        </td>
                                        <!--<td class="text-center pb-0">-->
                                        <!--<input class="form-control" style="min-width: 6rem;" type="number"-->
                                        <!--v-model="item.sellPrice" @input="thousandSeprator2(item)">-->
                                        <!--<small class="text-nowrap mt-2">{{item.salesPriceShow}}</small>-->
                                        <!--</td>-->
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center no-item-alert mt-5" v-if="middleProducts.length < 1">محصولی ثبت
                                    نشده
                                    است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description"
                                       placeholder="توضیحات">
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 w-100 text-right">
                                        <!--<div class="row">-->
                                        <!--<div class="col-md-6">-->
                                        <!--<span>تعداد کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallAmount}}</span>-->
                                        <!--</div>-->
                                        <!--<div class="col-md-6">-->
                                        <!--<span>مبلغ کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallPrice.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <!--</div>-->
                                    </div>
                                    <div class=" col-md-6 col-sm-6 w-100 text-right d-inline-flex">
                                        <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                        </button>
                                        <!--<button type="button" class="btn btn-primary m-1" @click="onModalOk2"-->
                                        <!--v-if="middleProducts.length > 0">ذخیره-->
                                        <!--</button>-->
                                        <button type="button" class="btn btn-success m-1" @click="onPaymentClicked"
                                                v-if="middleProducts.length > 0">ثبت محصولات استفاده شده در تولید
                                        </button>
                                        <!--<button type="button" class="d-inline-block btn btn-success m-1"-->
                                        <!--@click="onPrintClicked"><i-->
                                        <!--class="fa fa-print"></i></button>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from '../_framework/VsSelect.vue';
    import EventBus from "../_framework/event-bus.js";
    import {StreamBarcodeReader} from "vue-barcode-reader";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#productModal").modal("show");
    });

    export default {
        name: 'production',
        components: {
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                voucher: {
                    description: "",
                    receiveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0
                },

                products: [],
                units: [],
                categories: [],
                preselectedUnit: {},
                preselectedCategory: {},
                params: {
                    mode: 'create'
                },
                queryParams: {
                    name: "",
                    showAll: false,
                    pageSize: 18,
                    pageIndex: 0,
                },
                searchString: "",
                modalProductName: "",
                baseproduct: {
                    productId: 0,
                    productName: "",
                    count: 0,
                },
                product: {
                    productId: 0,
                    productName: "",
                    count: 0,
                },
                dataCount: 0,

                listView: false,
                autoload: false,
                baseProductSelected: false,
                barcode: "",
                categoryName: "",
                middleProducts: [],
                baseVoucherId: 0,
                middleVoucherId: 0,
                basProduct: {
                    voucherId: 0,
                    productId: 0,
                    name: "",
                    unitval: 0,
                    unit: ""
                },
                oldOutsourceList: [],
                isSending: false,
            }
        },
        mounted() {
            // console.log("prodddd")
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            // console.log(this.queryParams);
            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                // new BaseService('product?pageSize='
                //     + this.queryParams.pageSize
                //     + '&pageIndex='
                //     + this.queryParams.pageIndex
                //     + '&name='
                //     + this.queryParams.name
                //     + '&showAll='
                //     + this.queryParams.showAll).getList().then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });
            new BaseService('units').getAll().then(response => {
                this.units = response.data;
            }).catch(error => {
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });

            this.getCategories();

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();
                    }
                });
            }
            /*new BaseService('categories').getAll().then(response => {
                this.categories = response.data.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });*/
        },
        methods: {
            onModalShow() {
                $("#voucherData").modal("show");
                // console.log(this.middleProducts)
            },

            getCategories() {
                new BaseService('categories').getAll().then(response => {
                    this.categories = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onUnitChange(e) {
                if (e && e.id != null) {
                    this.preselectedUnit = e;
                    this.product.unitId = e.id;
                }
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                let queryParams2 = {
                    name: this.searchString,
                    showAll: false,
                    pageSize: 18,
                    pageIndex: 0,
                };
                // this.queryParams.categoryId = 0;
                // this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(queryParams2).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                if (this.baseProductSelected === false) {
                    this.baseproduct = this.products[index];
                    this.baseproduct.productId = this.baseproduct.id;
                    this.baseproduct.index = index;
                    this.params.mode = 'edit';


                    $("#productModal").modal("show");
                } else {
                    let flag = false;
                    let i = 0;
                    let offset = 0;
                    for (let item of this.middleProducts) {
                        if (item.productName === this.products[index].productName) {
                            flag = true;
                            offset = i;
                        }
                        i++;
                    }
                    if (flag === false) {
                        this.products[index].unitVal++;
                        Vue.set(this.products[index], "originalPrice", this.products[index].price);
                        Vue.set(this.products[index], "salesPrice", this.products[index].sellPrice);
                        this.middleProducts.push(this.products[index]);
                    } else {
                        this.middleProducts[offset].unitVal++;
                        //this.products[index].unitVal++;
                    }
                }
                console.log(this.baseproduct)
                console.log(this.middleProducts)
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.middleProducts[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.middleProducts.splice(index, 1);

            },
            onModalButtonClick() {
                $("#newproductModal").modal("show");
                let na = this.product.productName;
                this.product = {};
                if (this.preselectedUnit.id !== null) {
                    this.product.unitId = this.preselectedUnit.id;
                }
                if (this.preselectedCategory.id !== null) {
                    this.product.categoryId = this.preselectedCategory.id;
                }
                if (na !== null && na !== '') {
                    this.product.productName = na;
                }

                this.params.mode = 'create';
            },
            onModalDelete() {
                if (confirm("آیا از حذف این محصول اطمینان دارید؟")) {
                    new BaseService('product').delete(this.product.id).then(response => {
                        this.$noty.warning("با موفقیت حذف شد!");
                        $("#productModal").modal("hide");
                        $("#productModal").modal("hide");
                        new BaseService('product', '/get').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });

                }
            },
            onModalOk() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null ||this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate =  Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (this.baseproduct.unitVal === 0) {
                            Utils.handleErrorWithNotification("لطفا تعداد را انتخاب کنید", this.$noty);
                        } else if (this.baseproduct.price === 0) {
                            Utils.handleErrorWithNotification("لطفا قیمت را وارد کنید", this.$noty);
                        } else {
                            this.baseProductSelected = true;
                            this.products.splice(this.baseproduct.index, 1);
                            let voucher = {
                                description: "",
                                receiveOutSourceId: 0,
                                voucherProductDto: [
                                    this.baseproduct
                                ],
                                outSourceName: "",
                                overallAmount: 0,
                                overallPrice: 0
                            };
                            console.log(voucher);
                            new BaseService('Voucher', '/BaseProductionStok').create(voucher).then(response => {
                                this.$noty.success("کالای تولیدی با موفقیت اضافه شد.");

                                this.baseVoucherId = response.data.data;
                                $("#productModal").modal("hide");

                                this.basProduct.voucherId = this.baseVoucherId;
                                this.basProduct.productId = this.baseproduct.id;
                                this.basProduct.name = this.baseproduct.productName;
                                this.basProduct.unitval = this.baseproduct.unitVal;
                                this.basProduct.unit = this.baseproduct.unitName;
                                this.$router.push({
                                    name: 'productionSelectOutsource',
                                    params: {
                                        baseProduct: this.basProduct,
                                        oldOutsourceList: this.oldOutsourceList
                                    }
                                });
                                this.isSending = false;
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            });


                        }
                    }
                }
            },
            onModalOk2() {

                if (this.product.count === 0) {
                    Utils.handleErrorWithNotification("لطفا تعداد را انتخاب کنید", this.$noty);
                } else {
                    $("#productModal").modal("hide");

                    this.baseProductSelected = true;
                }
            },
            onPaymentClicked() {
                if (!this.isSending) {
                    this.isSending = true;
                    console.log(this.middleProducts);
                    for (let i of this.middleProducts) {
                        i.productId = i.id;
                    }
                    let voucher = {
                        description: "",
                        receiveOutSourceId: 0,
                        voucherProductDto:
                        this.middleProducts
                        ,
                        outSourceName: "",
                        overallAmount: 0,
                        overallPrice: 0,
                        productVoucherId: this.baseVoucherId
                    };
                    console.log(voucher);
                    new BaseService('Voucher', '/MiddleProductionStok').create(voucher).then(response => {
                        this.$noty.success("کالاهای مصرفی با موفقیت کسر شد.");

                        this.middleVoucherId = response.data.data;
                        $("#voucherData").modal("hide");

                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onCreate() {
            },
            onUpdate(product) {
                // console.log(product)
                new BaseService('product').update(product).then(response => {
                    this.$noty.success("موفقیت آمیز!");
                    $("#productModal").modal("hide");
                    this.queryParams.pageIndex = 0;
                    new BaseService('product', '/get').getList(this.queryParams).then(response => {
                        this.products = response.data.data;
                        $("#loading").hide();
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                    });
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                })
            },
            onCategoryChange(e) {
                if (e && e.id != null) {
                    this.preselectedCategory = e;
                    this.product.categoryId = e.id;
                }
            },
            onAddCategoryClicked() {
                $("#category-modal").modal("show");
                // $("#productModal").modal("hide");
                // this.$router.push({name: 'category'});
            },
            onSelectCategory(val) {
                this.queryParams.categoryId = val.id;
                this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onDecode(a, b, c) {
                // console.log(a, b, c);
                this.barcode = a;
                this.product.barcode = a;
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                // console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
            onCreateCategory() {
                if (!this.isSending) {
                    this.isSending = true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        // parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onProductModalOk() {
                this.onCreateProduct(this.product);
            },
            onCreateProduct(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    console.log(product)
                    if (product.categoryId === undefined || product.categoryId === null) {
                        Utils.handleErrorWithNotification("لطفا دسته بندی را انتخاب کنید", this.$noty);
                    } else if (product.unitId === undefined || product.unitId === null) {
                        Utils.handleErrorWithNotification("لطفا واحد را انتخاب کنید", this.$noty);
                    } else {
                        product.rowVersion = this.generateUuid();
                        new BaseService('product').create(product).then(response => {
                            this.$noty.success("موفقیت آمیز!");
                            $("#newproductModal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                                this.products = response.data.data;
                                $("#loading").hide();
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                        })
                    }
                }
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#newproductModal").hasClass("show")) {
                $("#newproductModal").modal("hide");
                next(false);
            } else {
                next();
            }
        },

        // created() {
        //     const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
        //         this.back();
        //
        //         // next(false)
        //     });
        //
        //     this.$once('hook:destroyed', () => {
        //         unregisterRouterGuard()
        //     });
        // },


    }
</script>

<style lang="scss">
    .vs-select {
        flex: 1;
    }

    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }

    .v-select .dropdown-toggle {
        padding: 4px 0 4px;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }

    .vs-select .dropdown-toggle::after {
        display: none;
    }

    .v-select .dropdown-toggle .clear {
        margin-top: 5px;
    }
</style>